import React from "react";
import ReactECharts from "echarts-for-react";
import { Box } from "@mui/material";

const PaiChartComponent = ({
  data,
  height = "100%",
  width = "100%",
  pdf,
  color = [
    "#444444",
    "#666666",
    "#808080",
    "#B3B3B3",
    "#E8D0B1",
    "#D5B98B",
    "#B29263",
  ],
  onEvents,
  title = "",
  lable = false,
}) => {
  return (
    <>
      <ReactECharts
        option={{
          title: {
            text: `{custom|${title}}`,
            left: "center",
            textStyle: {
              rich: {
                custom: {
                  fontSize: 16,
                  fontWeight: "bold",
                  color: "#333",
                },
              },
            },
          },
          legend: pdf
            ? {
                orient: "vertical",
                bottom: 0,
                left: 0,
                textStyle: {
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#000",
                },
              }
            : {
                bottom: "0%",
                textStyle: {
                  fontSize: 14,
                  fontWeight: 600,
                  color: "#000",
                },
              },
          color,
          tooltip: {
            trigger: "item",
            formatter: "{b}: ({d}%)",
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: "60%",
              data,
              label: {
                show: true,
                formatter: lable ? "{c}" : "{c} {b}",
                textStyle: {
                  fontWeight: "bold",
                  fontSize: 14,
                },
              },
              animation: false,
              animationDuration: 0,
              animationDurationUpdate: 0,
              emphasis: {
                itemStyle: {
                  shadowBlur: 10,
                  shadowOffsetX: 0,
                  shadowColor: "rgba(0, 0, 0, 0.5)",
                },
              },
            },
          ],
        }}
        onEvents={onEvents}
        style={{ height, width }}
      />
    </>
  );
};

export default PaiChartComponent;
